"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.faceAlignCrop = faceAlignCrop;
exports.init = init;
exports.file2img = file2img;
exports.canvas2blob = canvas2blob;
exports.blob2file = blob2file;
exports.canvasCrop = canvasCrop;
exports.canvasResize = canvasResize;
exports.canvasRotate = canvasRotate;
exports.faceRotation = faceRotation;
exports.downloadFile = downloadFile;
var i18n_1 = require("i18n");
// 改这个文件要自己tsc成js
// 改这个文件要自己tsc成js
// 改这个文件要自己tsc成js
// 重要的事情说三遍
/*
 * @Date: 2024-01-08 15:37:47
 * @LastEditors: fuRan NgeKaworu@gmail.com
 * @LastEditTime: 2024-09-14 15:49:28
 * @FilePath: /newwork-h5/src/utils/img/faceAlignCrop/index.ts
 */
var faceapi = require("face-api.js");
var TAG = 'FACE_ALIGN_CROP';
var BoxOffset = /** @class */ (function () {
    function BoxOffset(_a) {
        var _b = _a.top, top = _b === void 0 ? 0 : _b, _c = _a.left, left = _c === void 0 ? 0 : _c, _d = _a.right, right = _d === void 0 ? 0 : _d, _e = _a.bottom, bottom = _e === void 0 ? 0 : _e;
        this.top = top;
        this.left = left;
        this.right = right;
        this.bottom = bottom;
    }
    return BoxOffset;
}());
function faceAlignCrop(file) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, _b, _c, input, detections, offset, maxWidth, maxHeight, offsetBox, longSide, shortSide, scaleLongSide, rate, scaleShortSide, landscape, scaleBox, canvas, blob, output;
        var _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    // 加载模型
                    _b = (_a = console).log;
                    _c = [TAG, 'loaded model: '];
                    return [4 /*yield*/, init()];
                case 1:
                    // 加载模型
                    _b.apply(_a, _c.concat([_e.sent()]));
                    console.log(TAG, 'input file: ', file);
                    return [4 /*yield*/, file2img(file)
                        // 识别
                    ];
                case 2:
                    input = _e.sent();
                    return [4 /*yield*/, faceapi.detectSingleFace(input)];
                case 3:
                    detections = _e.sent();
                    console.log(TAG, 'detections: ', detections);
                    if (null == detections)
                        throw Error(i18n_1.default.t('照片人像不合法，请上传合法正面照'));
                    if (detections.score < 0.8)
                        throw Error(i18n_1.default.t('人脸识别失败，请调整角度重新拍摄'));
                    offset = new BoxOffset({
                        top: 160,
                        bottom: 96,
                        left: 80,
                        right: 80,
                    });
                    maxWidth = input.width;
                    maxHeight = input.height;
                    offsetBox = _offsetBox(detections.box, offset, maxWidth, maxHeight);
                    longSide = Math.max(offsetBox.width, offsetBox.height);
                    shortSide = Math.min(offsetBox.width, offsetBox.height);
                    scaleLongSide = 218;
                    rate = scaleLongSide / longSide;
                    scaleShortSide = shortSide * rate;
                    landscape = offsetBox.width > offsetBox.height;
                    scaleBox = {
                        width: landscape ? scaleLongSide : scaleShortSide,
                        height: landscape ? scaleShortSide : scaleLongSide,
                    };
                    console.log(TAG, 'scaleBox: ', scaleBox);
                    console.log(TAG, 'box: ', detections.box);
                    console.log(TAG, 'verticalOffsetBox: ', offsetBox);
                    canvas = canvasResize(canvasCrop(input, offsetBox), scaleBox);
                    return [4 /*yield*/, canvas2blob(canvas)];
                case 4:
                    blob = _e.sent();
                    return [4 /*yield*/, blob2file(blob, (_d = file === null || file === void 0 ? void 0 : file.name) !== null && _d !== void 0 ? _d : "".concat(Date.now(), ".jpeg"))];
                case 5:
                    output = _e.sent();
                    console.log(TAG, 'input file.size: ', "".concat(file.size / 1024, "Kb ").concat(file.size, "Byte"));
                    console.log(TAG, 'output file.size: ', "".concat(output.size / 1024, "Kb ").concat(output.size, "Byte"));
                    console.log(TAG, 'compression rate: ', "".concat(((1 - output.size / file.size) * 100).toFixed(2), "%"));
                    return [2 /*return*/, output];
            }
        });
    });
}
function _offsetBox(box, offset, maxWidth, maxHeight) {
    var left = Math.max(box.left - offset.left, 0);
    var top = Math.max(box.top - offset.top, 0);
    var right = Math.min(box.right + offset.right, maxWidth);
    var bottom = Math.min(box.bottom + offset.bottom, maxHeight);
    return new faceapi.Box({
        left: left,
        top: top,
        right: right,
        bottom: bottom,
    });
}
function init() {
    return __awaiter(this, arguments, void 0, function (PATH) {
        if (PATH === void 0) { PATH = "/".concat(process.env.BASE_URL, "/assets/weights/"); }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!faceapi.nets.ssdMobilenetv1.isLoaded) return [3 /*break*/, 2];
                    return [4 /*yield*/, faceapi.nets.ssdMobilenetv1.loadFromUri(PATH)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/, true];
            }
        });
    });
}
function file2img(file) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) {
                    var input = new Image();
                    input.onload = function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            URL.revokeObjectURL(input.src);
                            resolve(input);
                            return [2 /*return*/];
                        });
                    }); };
                    input.src = URL.createObjectURL(file);
                })];
        });
    });
}
function canvas2blob(canvas_1) {
    return __awaiter(this, arguments, void 0, function (canvas, type, quality) {
        if (type === void 0) { type = 'image/jpeg'; }
        if (quality === void 0) { quality = 0.8; }
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) {
                    // 将 canvas 转换为 data URL
                    canvas.toBlob(resolve, type, quality);
                })];
        });
    });
}
function blob2file(blob, name) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new File([blob], name, { type: blob.type })];
        });
    });
}
function canvasCrop(img, box) {
    var canvas = document.createElement('canvas');
    canvas.width = box.width;
    canvas.height = box.height;
    var ctx = canvas.getContext('2d');
    // 裁切
    ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(img, box.x, box.y, box.width, box.height, 0, 0, box.width, box.height);
    return canvas;
}
function canvasResize(img, box) {
    var canvas = document.createElement('canvas');
    canvas.width = box.width;
    canvas.height = box.height;
    var ctx = canvas.getContext('2d');
    // 裁切
    ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(img, 0, 0, box.width, box.height);
    return canvas;
}
function canvasRotate(img, rotate) {
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    // 设置 canvas 的大小为图片的大小
    canvas.width = img === null || img === void 0 ? void 0 : img.width;
    canvas.height = img === null || img === void 0 ? void 0 : img.height;
    if (ctx) {
        switch (rotate) {
            case 90: // 顺时针旋转90度
                canvas.width = img.height;
                canvas.height = img.width;
                ctx.rotate(Math.PI / 2);
                ctx.translate(0, -canvas.width);
                break;
            case 270: // 逆时针旋转90度
                canvas.width = img.height;
                canvas.height = img.width;
                ctx.rotate(-Math.PI / 2);
                ctx.translate(-canvas.height, 0);
                break;
            case 180: // 旋转180度
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.rotate(Math.PI);
                ctx.translate(-canvas.width, -canvas.height);
                break;
            case 0:
            default:
                canvas.width = img.width;
                canvas.height = img.height;
        }
    }
    ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(img, 0, 0);
    return canvas;
}
function faceRotation(file, rotate) {
    return __awaiter(this, void 0, void 0, function () {
        var input, canvas, blob, output;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, file2img(file)];
                case 1:
                    input = _b.sent();
                    canvas = canvasRotate(input, rotate);
                    return [4 /*yield*/, canvas2blob(canvas)];
                case 2:
                    blob = _b.sent();
                    return [4 /*yield*/, blob2file(blob, (_a = file === null || file === void 0 ? void 0 : file.name) !== null && _a !== void 0 ? _a : "".concat(Date.now(), ".jpeg"))];
                case 3:
                    output = _b.sent();
                    return [2 /*return*/, output];
            }
        });
    });
}
function downloadFile(data, filename, mimeType) {
    // Step 1: Create a Blob
    var blob = new Blob([data], { type: mimeType });
    // Step 2: Create a URL for the Blob
    var url = URL.createObjectURL(blob);
    // Step 3: Create an `<a>` Element
    var a = document.createElement('a');
    a.href = url;
    a.download = filename;
    // Append anchor to body.
    document.body.appendChild(a);
    // Step 4: Trigger the Download
    a.click();
    // Step 5: Clean Up
    URL.revokeObjectURL(url);
    // Remove the anchor from body
    document.body.removeChild(a);
}
